
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d38ca648&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Rankings.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Rankings.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-d38ca648!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Rankings.vue"),
  /* scopeId */
  "data-v-d38ca648",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Rankings.vue
// module id = 301
// module chunks = 2